import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=3b577d56"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=3b577d56&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b577d56')) {
      api.createRecord('3b577d56', component.options)
    } else {
      api.reload('3b577d56', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=3b577d56", function () {
      api.rerender('3b577d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/layout.vue"
export default component.exports